import { parseISO, format } from "date-fns";
import * as FileDownload from 'js-file-download';
const fileDownload: Function = FileDownload as any;

import { crudDelete } from "./request";
const { CrudModel } = require('./crud');

export class BankingFileModel extends CrudModel {
	constructor() {
		super('admin/banking_file', []);
	}

	async processBankingFile(fileContents: string) {
		return this.executeAction(null, "processBankingFile", { fileContents });
	}

	async getCnab(bankingFileId: number) {
		return this.executeAction(null, "getCnab", { bankingFileId });
	}

	async deleteBankingFile(bankingFileId: number) {
		return crudDelete(this.endpoint, bankingFileId, "Exclusão de arquivo bancário não pago");
	}

	downloadCnab(cnabInfo: { id: number, remittanceNumber?: number, createdDate: string, cnab: string }) {
		const remittanceNumber = cnabInfo.remittanceNumber || cnabInfo.id;
		const fileName = `SANTANDER_${remittanceNumber}_${format(parseISO(cnabInfo.createdDate), 'yyMMddHHmmss')}.rem`;
		fileDownload(cnabInfo.cnab, fileName);
	}
}

export default new BankingFileModel();
